export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
// Image state action types
export const ADD_IMAGE = "ADD_IMAGE";
export const GET_IMAGES = "GET_IMAGES";
